import { ChartColumnBig } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ChartColumnBigIcon = createLucideIcon(ChartColumnBig);
